var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListPanel',{attrs:{"portal":_vm.portal}})
}
var staticRenderFns = []

export { render, staticRenderFns }